import { BRAND, CONTACT } from '../../../core/constants/site';

import '../styles/privacy-policy.css';

function Pending({ children }) {
    return <mark className="privacy-policy__pending">{children}</mark>;
}

export default function PrivacyPolicy() {
    return (
        <article className="privacy-policy container">
            <header className="privacy-policy__header">
                <p className="eyebrow">Legal</p>
                <h1 className="privacy-policy__title">Política de tratamiento de datos personales</h1>
                <p className="privacy-policy__notice" role="note">
                    Borrador para revisión del cliente: los apartes resaltados deben confirmarse
                    antes de publicar el sitio.
                </p>
            </header>

            <section className="privacy-policy__section" aria-labelledby="policy-controller">
                <h2 id="policy-controller" className="privacy-policy__heading">1. Responsable del tratamiento</h2>
                <dl className="privacy-policy__facts">
                    <div className="privacy-policy__fact">
                        <dt>Razón social</dt>
                        <dd>{BRAND.legalName}</dd>
                    </div>
                    <div className="privacy-policy__fact">
                        <dt>NIT</dt>
                        <dd>{BRAND.taxId}</dd>
                    </div>
                    <div className="privacy-policy__fact">
                        <dt>Domicilio</dt>
                        <dd>{CONTACT.address}, {CONTACT.addressCity}, Colombia</dd>
                    </div>
                    <div className="privacy-policy__fact">
                        <dt>Correo</dt>
                        <dd>
                            <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>{' '}
                            <Pending>confirmar correo corporativo definitivo</Pending>
                        </dd>
                    </div>
                    <div className="privacy-policy__fact">
                        <dt>Teléfono</dt>
                        <dd>{CONTACT.whatsappDisplay}</dd>
                    </div>
                </dl>
            </section>

            <section className="privacy-policy__section" aria-labelledby="policy-scope">
                <h2 id="policy-scope" className="privacy-policy__heading">2. Marco legal y alcance</h2>
                <p>
                    Esta política se adopta en cumplimiento de la Ley 1581 de 2012 y del Decreto
                    1377 de 2013 (compilado en el Decreto 1074 de 2015). Aplica a los datos
                    personales que {BRAND.legalName} recibe a través de los canales de contacto
                    publicados en este sitio: WhatsApp, teléfono y correo electrónico.
                </p>
                <p>
                    Este sitio no tiene formularios, no crea cuentas de usuario y no usa cookies
                    propias de analítica ni de publicidad.
                </p>
            </section>

            <section className="privacy-policy__section" aria-labelledby="policy-data">
                <h2 id="policy-data" className="privacy-policy__heading">3. Datos que se recolectan</h2>
                <p>
                    Cuando una persona escribe o llama, se reciben los datos que ella misma
                    suministra: nombre, número de teléfono, correo electrónico, empresa o entidad
                    que representa y la información del proyecto o servicio que consulta. No se
                    solicitan datos sensibles ni datos de niños, niñas o adolescentes.
                </p>
            </section>

            <section className="privacy-policy__section" aria-labelledby="policy-purposes">
                <h2 id="policy-purposes" className="privacy-policy__heading">4. Finalidades</h2>
                <ul className="privacy-policy__list">
                    <li>Responder solicitudes de información y elaborar cotizaciones.</li>
                    <li>Gestionar la relación comercial y contractual con clientes y proveedores.</li>
                    <li>Cumplir obligaciones legales, contables y tributarias.</li>
                    <li>Hacer seguimiento a los servicios prestados y atender peticiones, quejas y reclamos.</li>
                    <li>
                        <Pending>
                            Confirmar si se enviará información comercial o promocional; de ser así,
                            debe quedar como finalidad expresa.
                        </Pending>
                    </li>
                </ul>
            </section>

            <section className="privacy-policy__section" aria-labelledby="policy-rights">
                <h2 id="policy-rights" className="privacy-policy__heading">5. Derechos del titular</h2>
                <p>De acuerdo con el artículo 8 de la Ley 1581 de 2012, el titular puede:</p>
                <ul className="privacy-policy__list">
                    <li>Conocer, actualizar y rectificar sus datos personales.</li>
                    <li>Solicitar prueba de la autorización otorgada.</li>
                    <li>Ser informado sobre el uso que se ha dado a sus datos.</li>
                    <li>Revocar la autorización o solicitar la supresión de sus datos cuando no exista un deber legal o contractual de conservarlos.</li>
                    <li>Acceder de forma gratuita a los datos que hayan sido objeto de tratamiento.</li>
                    <li>Presentar quejas ante la Superintendencia de Industria y Comercio por infracciones a la ley.</li>
                </ul>
            </section>

            <section className="privacy-policy__section" aria-labelledby="policy-procedure">
                <h2 id="policy-procedure" className="privacy-policy__heading">6. Cómo ejercer los derechos</h2>
                <p>
                    Las consultas y reclamos se reciben en el correo{' '}
                    <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a> o en la dirección física
                    indicada arriba, con el nombre completo del titular, un medio de contacto y la
                    descripción de la solicitud. <Pending>Indicar el área o la persona responsable de atenderlas.</Pending>
                </p>
                <ul className="privacy-policy__list">
                    <li>Consultas: se responden en un máximo de diez (10) días hábiles, prorrogables por cinco (5) días hábiles más.</li>
                    <li>Reclamos: se responden en un máximo de quince (15) días hábiles, prorrogables por ocho (8) días hábiles más.</li>
                </ul>
            </section>

            <section className="privacy-policy__section" aria-labelledby="policy-third-parties">
                <h2 id="policy-third-parties" className="privacy-policy__heading">7. Servicios de terceros</h2>
                <p>
                    Los datos no se venden ni se ceden a terceros con fines comerciales. Para operar
                    los canales de contacto se usan servicios de terceros que tratan la información
                    según sus propias políticas: WhatsApp (Meta), el proveedor del correo electrónico
                    y el proveedor de alojamiento del sitio.
                </p>
                <p>
                    El video del portafolio se aloja en YouTube y solo se carga cuando el visitante
                    decide reproducirlo; a partir de ese momento YouTube (Google) puede usar sus
                    propias cookies.
                </p>
            </section>

            <section className="privacy-policy__section" aria-labelledby="policy-retention">
                <h2 id="policy-retention" className="privacy-policy__heading">8. Seguridad y conservación</h2>
                <p>
                    {BRAND.legalName} aplica medidas razonables para evitar el acceso no autorizado,
                    la pérdida o la alteración de los datos, y los conserva durante el tiempo
                    necesario para cumplir las finalidades descritas y las obligaciones legales
                    aplicables.
                </p>
            </section>

            <section className="privacy-policy__section" aria-labelledby="policy-validity">
                <h2 id="policy-validity" className="privacy-policy__heading">9. Vigencia</h2>
                <p>
                    Esta política rige a partir de <Pending>fecha de entrada en vigencia</Pending>.
                    Cualquier cambio sustancial se publicará en esta misma página.
                </p>
            </section>

            <a className="button button--ghost privacy-policy__back" href="/">Volver al inicio</a>
        </article>
    );
}
